"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiSelect = exports.ClearContext = exports.CLEAR_OPTION_VALUE = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var _reactMultiSelectComponent = require("react-multi-select-component");
var _chevronDown = require("../../../assets/icons/chevron-down.svg");
var _multiSelectModule = _interopRequireDefault(require("./multi-select.module.scss"));
var _classnames = _interopRequireDefault(require("classnames"));
var _noop = require("../../../utils/noop");
var _ItemRenderer = _interopRequireDefault(require("./ItemRenderer"));
var CLEAR_OPTION_VALUE = 'CLEAR_OPTION_VALUE';
// We use context for passing "props" to ItemRenderer, because declaring it inline
// causes a bug in the library - clicking the first option and then bluring doesnt close
// the dropdown
exports.CLEAR_OPTION_VALUE = CLEAR_OPTION_VALUE;
var ClearContext = /*#__PURE__*/_react.default.createContext({
  clearAll: _noop.noop,
  options: []
});
exports.ClearContext = ClearContext;
var MultiSelect = function MultiSelect(_ref) {
  var _classNames;
  var _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    value = _ref.value,
    options = _ref.options,
    onChange = _ref.onChange,
    labelledBy = _ref.labelledBy,
    variant = _ref.variant,
    className = _ref.className,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error,
    valueRenderer = _ref.valueRenderer,
    _ref$inline = _ref.inline,
    inline = _ref$inline === void 0 ? false : _ref$inline,
    _ref$withClearAll = _ref.withClearAll,
    withClearAll = _ref$withClearAll === void 0 ? false : _ref$withClearAll,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? /*#__PURE__*/_react.default.createElement(_chevronDown.ReactComponent, {
      className: _multiSelectModule.default['multi-select__icon']
    }) : _ref$icon;
  var mappedOptions = (0, _react.useMemo)(function () {
    var selectOptions = options.map(function (o) {
      return {
        label: o.label,
        value: o.value
      };
    });
    if (withClearAll) {
      selectOptions.push({
        label: '',
        value: 'CLEAR_OPTION_VALUE'
      });
    }
    return selectOptions;
  }, [options, withClearAll]);
  var mappedValue = (0, _react.useMemo)(function () {
    return value.map(function (v) {
      return mappedOptions.find(function (o) {
        return o.value === v;
      });
    });
  }, [value, mappedOptions]);
  var handleChange = (0, _react.useCallback)(function (options) {
    var values = options.filter(function (o) {
      return o.value !== CLEAR_OPTION_VALUE;
    }).map(function (o) {
      return o.value;
    });
    onChange(values);
  }, [onChange]);
  var _useState = (0, _react.useState)(1),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    key = _useState2[0],
    setKey = _useState2[1];
  var clearAll = (0, _react.useCallback)(function () {
    onChange([]);
    setKey(function (key) {
      return key + 1;
    });
  }, [onChange]);
  var contextValue = (0, _react.useMemo)(function () {
    return {
      clearAll: clearAll,
      options: mappedOptions
    };
  }, [clearAll, mappedOptions]);
  return /*#__PURE__*/_react.default.createElement(ClearContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/_react.default.createElement(_reactMultiSelectComponent.MultiSelect, {
    key: key,
    className: (0, _classnames.default)(_multiSelectModule.default['multi-select'], className, (_classNames = {}, (0, _defineProperty2.default)(_classNames, _multiSelectModule.default['multi-select--small'], variant === 'small'), (0, _defineProperty2.default)(_classNames, _multiSelectModule.default['multi-select--error'], error), (0, _defineProperty2.default)(_classNames, _multiSelectModule.default['multi-select--inline'], inline), _classNames)),
    valueRenderer: valueRenderer,
    disableSearch: true,
    value: mappedValue,
    options: mappedOptions,
    labelledBy: labelledBy,
    hasSelectAll: false,
    disabled: disabled,
    onChange: handleChange,
    ClearSelectedIcon: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null),
    ArrowRenderer: function ArrowRenderer() {
      return icon;
    },
    ItemRenderer: _ItemRenderer.default
  }));
};
exports.MultiSelect = MultiSelect;